import React from 'react';
import styled from 'styled-components';

const StyledHeroSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
  padding: 0;
  text-align: left;

  /* The section gap owns spacing so paragraph margin resets cannot change it. */
  > p {
    margin: 0;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
  }

  h1 {
    margin: 0;
    /* Compensate for the large F's inset so the visible letters align. */
    margin-left: calc(1px - 0.06em);
  }
`;

const Hero = () => (
  <StyledHeroSection>
    <p>Hi, my name is</p>
    <h1 className="big-heading">Felix Gan.</h1>
  </StyledHeroSection>
);

export default Hero;
